import { LocalDateTime, LocalTime } from 'js-joda'

export interface IContact {
    title: string;
    firstName: string;
    lastName: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    county: string;
    country: string;
    postalCode: string;
    mobileNumber: string;
    emailAddress: string;
}

export interface IPriceItem {
    label: string
    price: number
    showPrice: boolean
    departureId?: string
    id: string
}

export interface IVehicle {
    id: string,
    count: number,
    description: string;
    registrationNumber: string;
    trailer?: ITrailer;
}

export interface ITrailer {
    id: string,
    registrationNumber: string
}

export interface IRoomArrangement {
    id: string;
    description: string;
    roomASTs: IRoomAst[];
}

export interface IRoomAst {
    description: string;
    componentGenericId: string
    count: number
}

export interface IRoom {
    description: string;
    seatingTime: LocalTime
    restaurantCode: string
    roomArrangements: IRoomArrangement[];
    roomCode: string
}

export interface IDeparture {
    departureId: string;
    departureDateTime: LocalDateTime;
    arrivalDateTime: LocalDateTime;
    routeName: string;
    routeCode: string;
    hasCabinArrangements: boolean;
    cabins: ICabin[];
    pets: IPet[];
    rooms: IRoom[];
    vehicles: IVehicle[];
    voucherArrangements: IVoucherArrangement[];
}

export interface IDepartureSelection {
    oldDepartureId: string,
    newDepartureId: string
}

export interface IPet {
    count: number
    description: string
}

export interface IVoucherArrangement {
    description: string
    voucherAsts: IVoucherAsts[]
    id: string
}

export interface IVoucherAsts {
    id: string
    count: number;
    description: string;
}

export interface ICabin {
    id: string;
    cabinArrangements: ICabinArrangement[];
    count: number;
    description: string;
    categoryCode: string;
}

export interface ICabinArrangement {
    cabinArrangementASTs: ICabinArrangementAst[]
}

export interface ICabinArrangementAst {
    count: number;
    description: string;
}

export interface IPassenger {
    id: string;
    customerCategory: CustomerCategory;
    title: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    nationalityCode: string;
    passportNumber: string;
}

export interface ILoyaltyCard {
    provider: number
    cardNumber: string
    points: number
    loyaltyAction: LoyaltyActionEnum
}

export enum LoyaltyActionEnum {
    noCard = 'noCard',
    newCard = 'newCard',
    existingCard = 'existingCard'
}

export type CustomerCategory = 'INFANT' | 'ADULT' | 'CHILD'

export interface IReservation {
    totalPaid: number;
    totalPrice: number;
    remainingAmount: number;
    creditCard: string;
    confirmedDate: LocalDateTime;
    modifiedDate: LocalDateTime;
    bookingDate: LocalDateTime;
    reservationStatus: string;
    reservationCode: string;
    isReadOnly: boolean;
    isAgentBooking: boolean;
    isMiniCruise: boolean;
    agentContact?: string;
    currencyCode: string;
    mealsIncluded: string;
    salesOwnerId: number;
    offerCode: string;
    originalSalesChannelCode: string;
    locale: string;
    contact: IContact;
    priceItems: IPriceItem[];
    accommodations: IAccommodation[];
    arrangements: IArrangement[];
    departures: IDeparture[];
    passengers: IPassenger[];
    childrenAges: number[]
    routeCode: string;
    productCode: string;
    productDescription: string;
    payOnline: boolean;
    agentType: string
}

export interface IArrangement {
    description: string
    arrangementAsts: IArrangementAsts[]
    id: string
}

export interface IArrangementAsts {
    count: number;
    description: string;
    id: string
    optionId: string
}

export interface IAccommodation {
    description: string
    accommodationRooms: IAccommodationRooms[]
}

export interface IAccommodationRooms {
    count: number;
    description: string;

}

// Must match: ErrorMessageWire.cs
export interface IErrorMessageWire {
    message: string
    errorCode: number
}

// Must match: ReservationErrorWire.cs
export interface IReservationErrorWire {
    reservation: IReservation
    errorMsgs: IErrorMessageWire[]
}
